import React, { ChangeEvent, memo, useEffect, useState } from 'react'
import styled from 'styled-components'

import InputTitle from 'components/Input/InputTitle'
import InputHeaderRow from 'components/Input/InputHeaderRow'
import NumericInput from 'components/Input/NumericInput'
import { useAppDispatch, useAppSelector } from 'state/hooks'
import { setDesireMode, setOrderSize, setOrderTotal } from 'state/exchange/reducer'
import {
  selectCurrentMarketInfo,
  selectOrderDirection,
  selectOrderPrice,
  selectOrderTotal,
  selectOrderType,
  selectOrderSize
} from 'state/exchange/selectors'
import { selectBalanceInBank } from 'state/wallet/selectors'
import { selectOraclePrices } from 'state/prices/selectors'
import { OrderDirection } from '@bitly/sdk/types'
import { formatDollars } from 'utils/prices'

type MarginInputProps = {
	isMobile?: boolean
}

const TotalInput: React.FC<MarginInputProps> = memo(({ isMobile }) => {
	const dispatch = useAppDispatch()
	const orderTotal = useAppSelector(selectOrderTotal)
	const marketInfo = useAppSelector(selectCurrentMarketInfo)
	const orderPrice = Number(useAppSelector(selectOrderPrice))
	const orderDirection = useAppSelector(selectOrderDirection)
	const orderType = useAppSelector(selectOrderType)
	const oraclePrices = useAppSelector(selectOraclePrices)
	const [oraclePrice, setOraclePrice] = useState<number>(0)

	useEffect(() => {
		if (marketInfo?.tokenY.symbol && oraclePrices) {
			const price = oraclePrices[marketInfo.tokenY.symbol]
			setOraclePrice(price ?? 0)
		}
	}, [marketInfo, oraclePrices])

	const onChangeValue = (_: ChangeEvent<HTMLInputElement>, v: string) => {
		dispatch(setOrderTotal(v))
		dispatch(setDesireMode(orderDirection === OrderDirection.sell ? true : false))
	}

	return (
		<>
			<InputHeaderRow
				label={
					<StyledInputTitle>
						Total ({marketInfo?.tokenY.symbol}) = {formatDollars(Number(orderTotal) * oraclePrice)}
					</StyledInputTitle>
				}
			></InputHeaderRow>

			<NumericInput
				dataTestId={'set-order-margin-susd' + (isMobile ? '-mobile' : '-desktop')}
				value={orderTotal}
				placeholder="0.00"
				right={false}
				onChange={onChangeValue}
			/>
		</>
	)
})

const StyledInputTitle = styled(InputTitle)`
	text-transform: capitalize;
`

export default TotalInput
